var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Print(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.4 34H55V11H21v23h-1.4a7.6 7.6 0 00-7.6 7.6V54h9v11h34V54h9V41.6a7.6 7.6 0 00-7.6-7.6zM51 61H25V46h26v15zm0-27H25V15h26v19zm6.21 9a2 2 0 110-4 2 2 0 010 4zM47 23H29v-3h18v3zm-9 6h-9v-3h9v3z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Print.3e98452f.svg";
export { SvgJ2Print as ReactComponent };